import { defineMessages, useIntl } from 'react-intl';
import { useContext } from 'react';
import { Edit } from '@carbon/icons-react';

import CommonButton from 'Components/Common/CommonButton/CommonButton';
import { AllEntitiesContext } from 'Screens/Dashboard/AllEntities/AllEntitiesProvider/AllEntitiesProvider';
import RemoveEntityButton from 'Screens/Dashboard/AllEntities/EntityTable/EntityInteractions/RemoveEntityButton/RemoveEntityButton';
import RefreshInvitationTokenButton from 'Screens/Dashboard/AllEntities/EntityTable/EntityInteractions/RefreshInvitationTokenButton/RefreshInvitationTokenButton';
import useGetUserPermission from 'hooks/useGetUserPermission';
import { UserRole } from 'api/dtos/user';
import QrCodeModal from './QrCodeModal/QrCodeModal';

type Props = {
    id: string;
    role: UserRole;
}

const EntityInteractions = ({ id, role }: Props) => {
    const intl = useIntl();
    const context = useContext(AllEntitiesContext);
    const { isAdmin, isOwner } = useGetUserPermission();

    const onEditRequest = () => {
        context?.setCurrentEntityId(id);
    };

    return (
        <div>
            <RemoveEntityButton id={id} role={role} />
            <RefreshInvitationTokenButton id={id} />
            <QrCodeModal id={id} />
            <CommonButton
                label={intl.formatMessage(messages.editLabel)}
                kind="ghost"
                disabled={!isAdmin && !isOwner}
                icon={<Edit size={21} />}
                onClick={onEditRequest}
            />
        </div>
    );
};

const messages = defineMessages({
    editLabel: {
        id: 'src.Screens.Dashboard.AllEntities.EntityTable.EntityInteractions.EntityInteractions.editLabel',
        defaultMessage: 'Edytuj grupę',
    },

});

export default EntityInteractions;
